import axios from "axios";

import getErrorDetails from "./helpers/getErrorDetails.js";
import paramsSerializer from "./helpers/paramsSerializer";
import { addPaginationAndSort, ORDER_DESC } from "./helpers/pagination";
import { Account } from "../models/Account";
import { identity, pickBy } from "lodash";

export async function getAccounts(
  params: any,
  options: any
): Promise<{
  list: Account[];
  totalItems: number;
  page: number;
}> {
  const requestParams = addPaginationAndSort<Account>({
    orderBy: "createdAt",
    order: ORDER_DESC,
    ...params,
  });
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: "/accounts",
      params: {
        ...requestParams,
        virtual: false,
      },
      paramsSerializer,
    });
    const { data = [] } = response;

    return {
      list: data,
      totalItems: data.length,
      page: 0,
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function getAccount(id: string, options: any): Promise<Account> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/accounts/${id}`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function postAccount(
  account: Account,
  options: any
): Promise<Account> {
  try {
    const response = await axios({
      ...options,
      method: "POST",
      url: `/accounts`,
      data: pickBy(
        {
          ...account,
          currency: account.currency.id,
          country: account.country.id,
          swiftBic: account.swiftBic || null,
        },
        identity
      ),
    });
    const { data = {} } = response;
    return await getAccount(data.id, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function patchAccount(
  id: string,
  account: Account,
  options: any
): Promise<Account> {
  try {
    const response = await axios({
      ...options,
      method: "PUT",
      url: `/accounts/${id}`,
      data: {
        ...pickBy(
          {
            ...account,
            country: account.country?.id || null,
            currency: account.currency?.id || null,
          },
          identity
        ),
        active: account.active,
      },
    });
    const { data = {} } = response;
    return await getAccount(data.id, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
}
